import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, useNavigate } from "react-router-dom";
import { auth } from "./firebase";
import HomePage from "./pages/HomePage";
import LoginSignupPage from "./pages/LoginSignupPage";
import OnboardingPage from "./pages/OnboardingPage";
import DashboardPage from "./pages/DashboardPage";
import DataInputPage from "./pages/DataInputPage";
import FoodLoggingPage from "./pages/FoodLoggingPage";
import ProfilePage from "./pages/ProfilePage";
import RecommendationsPage from "./pages/RecommendationsPage";
import CreateAccountPage from "./pages/CreateAccountPage";

// Wrapper component to handle navigation
const NavigationWrapper = ({ children }) => {
  useEffect(() => {
    // Check if this is a page refresh
    if (performance.navigation.type === 1) {
      window.location.href = 'https://mastermyhealthai.com';
    }
  }, []);

  return children;
};

const App = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <Router>
      <NavigationWrapper>
        <Routes>
          <Route path="/" element={user ? <HomePage /> : <LoginSignupPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/data-input" element={<DataInputPage />} />
          <Route path="/food" element={<FoodLoggingPage />} />
          <Route path="/profile-setup" element={<OnboardingPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/recommendations" element={<RecommendationsPage />} />
          <Route path="/create-account" element={<CreateAccountPage />} />
          <Route path="/loginsignup" element={<LoginSignupPage />} />
        </Routes>
      </NavigationWrapper>
    </Router>
  );
};

export default App;